import { TInspectionTaskLink } from "../../types/types"

type Props = {
    links: TInspectionTaskLink | TInspectionTaskLink[]
}

const TrainingLinks = ({ links }: Props) => {
    return Array.isArray(links) ? links.map((link) => {
        return <a key={link.itLinkId} className="underline text-sky-500 text-base" href={link?.linkUrl} target="_blank" rel="noopener noreferrer">{link?.linkText}</a>
    }) :
        <a className="underline text-sky-500 text-base" href={links?.linkUrl} target="_blank" rel="noopener noreferrer">{links?.linkText}</a>
}

export default TrainingLinks